var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 6.125V4.375C11.375 1.925 9.45 0 7 0C4.55 0 2.625 1.925 2.625 4.375V6.125C1.1375 6.125 0 7.2625 0 8.75V14.875C0 16.3625 1.1375 17.5 2.625 17.5H11.375C12.8625 17.5 14 16.3625 14 14.875V8.75C14 7.2625 12.8625 6.125 11.375 6.125ZM4.375 4.375C4.375 2.8875 5.5125 1.75 7 1.75C8.4875 1.75 9.625 2.8875 9.625 4.375V6.125H4.375V4.375ZM7.875 13.125C7.875 13.65 7.525 14 7 14C6.475 14 6.125 13.65 6.125 13.125V10.5C6.125 9.975 6.475 9.625 7 9.625C7.525 9.625 7.875 9.975 7.875 10.5V13.125Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLock);
export default __webpack_public_path__ + "static/media/ico-lock.a11f17c164fe71c1ba35b9a3437328c3.svg";
export { ForwardRef as ReactComponent };